import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CpDocumentRequestModel } from '../../helpers/objects/request/document/cp-document-request-model';
import { map, Observable } from 'rxjs';
import { CpDocumentResponseModel } from '../../helpers/objects/response/document/cp-document-response-model';
import { CpSetupDocumentModel } from '../../helpers/objects/dto/setup-document/cp-setup-document-model';
import {
  CpCompanyFilesSetupModel
} from '../../helpers/objects/dto/company-files/cp-company-files-setup-model';
import {
  CpCompanyDocumentsResponseModel
} from '../../helpers/objects/response/company-documents/cp-company-documents-response-model';

@Injectable({
  providedIn: 'root'
})
export class CpDocumentsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(token: string, request: CpDocumentRequestModel): Observable<CpDocumentResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/documents', { params })
      .pipe(map((response) => response.body as CpDocumentResponseModel));
  }

  getSetup(token: string): Observable<CpSetupDocumentModel[]> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/documents-setup')
      .pipe(map((response) => response.body as CpSetupDocumentModel[]));
  }

  getCompanyFiles(token: string, fileType: string): Observable<CpCompanyDocumentsResponseModel> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/companies-files/' + fileType + '/setup')
      .pipe(map((response) => response.body as CpCompanyDocumentsResponseModel));
  }
}
